import { IEvent } from "@Interfaces";
import { useNeedUserInputToProceed } from "@Modules/eventPage/utils/useNeedUserInputToProceed";
import { ACTION_TYPES } from "@Redux";
import { useEventDataOfSelectedEvent } from "@Utils";
import { useDispatch } from "react-redux";
import { fetchOfferingVariationsData } from "./OfferingVariationSelector.utils";

export const useOfferingVariations = () => {
    const dispatch = useDispatch();
    const { eventData } = useEventDataOfSelectedEvent();

    const { dontAllowUserToProceed, allowUserToProceed } =
        useNeedUserInputToProceed();

    const offeringVariations = eventData?.offeringVariations
        ? eventData?.offeringVariations.map(item => ({
              ...item,
              label: `${item.title}`,
              value: item.uuid,
          }))
        : [];

    const selectedVariation = eventData?.selectedOfferingVariation;

    const fetchOfferingVariations = async () => {
        if (!eventData.is_offering_variants_enabled) return;
        dontAllowUserToProceed({
            messageForUserToProceed:
                "Please select an variation before proceeding",
        });

        const response = await fetchOfferingVariationsData(eventData?.uuid);

        dispatch({
            type: ACTION_TYPES.EVENT.SET_OFFERING_VARIATIONS,
            payload: { response: response?.data },
        });
    };

    const handleOnChange = (value: IEvent.IOfferingVariation) => {
        allowUserToProceed();
        dispatch({
            type: ACTION_TYPES.EVENT.SET_SELECTED_OFFERING_VARIATION,
            payload: value,
        });
        dispatch({
            type: ACTION_TYPES.EVENT.UPDATE_DISCOUNT,
            payload: {
                discount: "",
            },
        });
    };

    const sectionTitle =
        eventData?.metadata?.default_plan_text || "Choose a Plan";

    return {
        fetchOfferingVariations,
        offeringVariations,
        handleOnChange,
        selectedVariation,
        is_offering_variants_enabled: eventData?.is_offering_variants_enabled,
        sectionTitle,
    };
};
